export default "__VITE_ASSET__iLl5P0CC__"